/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

import * as t from 'ts-schema';
export const appCollectionItemsResponseSchema = t.object({
  total: t.number,
  offeringIds: t.array(t.number)
});
export const collectionIdsResponseSchema = t.object({
  collectionIds: t.array(t.number)
});
export const collectionListingDetailsSchema = t.object({
  canonicalUrl: t.optional(t.string),
  description: t.string,
  displayed: t.boolean,
  htmlPageTitle: t.string,
  id: t.number,
  metaDescription: t.string,
  name: t.string,
  slug: t.string,
  tagline: t.string,
  title: t.string,
  updatedAt: t.number
});
export const collectionResponseSchema = t.object({
  createdAt: t.number,
  id: t.number,
  internalName: t.string,
  publishedListing: collectionListingDetailsSchema,
  type: t.union(t.literal('STATIC'), t.literal('DYNAMIC'))
});
export const collectionsResponseSchema = t.object({
  collections: t.array(collectionResponseSchema)
});
export const errorDetailSchema = t.object({
  code: t.optional(t.string),
  in: t.optional(t.string),
  message: t.string,
  subCategory: t.optional(t.string),
  context: t.optional(t.record(t.string, t.array(t.string)))
});
export const errorSchema = t.object({
  category: t.string,
  correlationId: t.string,
  message: t.string,
  subCategory: t.optional(t.string),
  context: t.optional(t.record(t.string, t.array(t.string))),
  errors: t.optional(t.array(errorDetailSchema)),
  links: t.optional(t.record(t.string, t.string))
});

/** get-/marketplace/quality/customer/v1/self-serve/apps/collections/{collection-id}/items <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:AppCollectionsResource+type:symbol+getItems&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-App_Collections-get-%2Fmarketplace%2Fquality%2Fcustomer%2Fv1%2Fself-serve%2Fapps%2Fcollections%2F%7Bcollection-id%7D%2Fitems'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmarketplace%2Fquality%2Fcustomer%2Fv1%2Fself-serve%2Fapps%2Fcollections%2F%28%28%7Bcollection-id%7D%29%29%2Fitems?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span> */
export const getCollectionItemsResponseSchema = appCollectionItemsResponseSchema;
export const getCollectionItemsFailureSchema = errorSchema;

/** get-/marketplace/quality/customer/v1/self-serve/apps/collections/published/relevant/ids <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:AppCollectionsResource+type:symbol+getRelevantPublishedCollectionIds&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-App_Collections-get-%2Fmarketplace%2Fquality%2Fcustomer%2Fv1%2Fself-serve%2Fapps%2Fcollections%2Fpublished%2Frelevant%2Fids'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmarketplace%2Fquality%2Fcustomer%2Fv1%2Fself-serve%2Fapps%2Fcollections%2Fpublished%2Frelevant%2Fids?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span> */
export const getPublishedCollectionRelevantIdsResponseSchema = collectionIdsResponseSchema;
export const getPublishedCollectionRelevantIdsFailureSchema = errorSchema;

/** get-/marketplace/quality/customer/v1/self-serve/apps/collections/published <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:AppCollectionsResource+type:symbol+getAllPublished&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-App_Collections-get-%2Fmarketplace%2Fquality%2Fcustomer%2Fv1%2Fself-serve%2Fapps%2Fcollections%2Fpublished'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fmarketplace%2Fquality%2Fcustomer%2Fv1%2Fself-serve%2Fapps%2Fcollections%2Fpublished?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span> */
export const getPublishedCollectionsResponseSchema = collectionsResponseSchema;
export const getPublishedCollectionsFailureSchema = errorSchema;